import { render } from "./StaffDetail.vue?vue&type=template&id=264b4a46&scoped=true"
import script from "./StaffDetail.vue?vue&type=script&lang=js"
export * from "./StaffDetail.vue?vue&type=script&lang=js"

import "./StaffDetail.vue?vue&type=style&index=0&id=264b4a46&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264b4a46"]])

export default __exports__